import { Link } from "react-router-dom";
import { Instagram, Lock, ShoppingBag } from "lucide-react";
import { LogoMark, TikTokIcon } from "./Logo";
import { useLang } from "@/context/LanguageContext";
import { IG_PROFILE_URL, TIKTOK_URL, VINTED_URL, scrollToId } from "@/lib/constants";

export const Footer = () => {
  const { t } = useLang();
  return (
    <footer data-testid="site-footer" className="border-t border-edge bg-[#070D18] text-[#F2F5FA]">
      <div className="mx-auto flex max-w-7xl flex-col gap-8 px-5 py-12 md:flex-row md:items-center md:justify-between md:px-8">
        <div className="flex items-start gap-4">
          <LogoMark size={40} />
          <div>
            <span className="font-display text-lg font-bold tracking-tight select-none">
              hello<span className="italic">vintora</span>
            </span>
            <p className="mt-2 max-w-xs text-xs leading-relaxed text-white/50">{t.footer.tagline}</p>
            <p className="mt-2 flex items-center gap-1.5 font-mono text-[10px] uppercase tracking-widest text-white/40">
              <ShoppingBag size={11} /> {t.footer.payment}
            </p>
          </div>
        </div>
        <div className="flex flex-wrap items-center gap-3">
          <button data-testid="footer-shop-link" onClick={() => scrollToId("katalog")} className="border border-white/15 px-4 py-2.5 font-mono text-[11px] uppercase tracking-widest text-white/70 transition-colors hover:border-white hover:text-white">
            {t.nav.shop}
          </button>
          <button data-testid="footer-contact-link" onClick={() => scrollToId("kontakt")} className="border border-white/15 px-4 py-2.5 font-mono text-[11px] uppercase tracking-widest text-white/70 transition-colors hover:border-white hover:text-white">
            {t.nav.contact}
          </button>
          <a data-testid="footer-vinted-link" href={VINTED_URL} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 border border-white/15 px-4 py-2.5 font-mono text-[11px] uppercase tracking-widest text-white/70 transition-colors hover:border-white hover:text-white">
            <ShoppingBag size={13} /> Vinted
          </a>
          <a data-testid="footer-tiktok-link" href={TIKTOK_URL} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 border border-white/15 px-4 py-2.5 font-mono text-[11px] uppercase tracking-widest text-white/70 transition-colors hover:border-white hover:text-white">
            <TikTokIcon size={12} /> @vintora8
          </a>
          <a data-testid="footer-instagram-link" href={IG_PROFILE_URL} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 border border-white/15 px-4 py-2.5 font-mono text-[11px] uppercase tracking-widest text-white/70 transition-colors hover:border-white hover:text-white">
            <Instagram size={13} /> @hellovintora
          </a>
          <Link data-testid="footer-admin-link" to="/admin" className="flex items-center gap-2 border border-white/15 px-4 py-2.5 font-mono text-[11px] uppercase tracking-widest text-white/50 transition-colors hover:border-white hover:text-white">
            <Lock size={12} /> {t.nav.admin}
          </Link>
        </div>
      </div>
      <div className="border-t border-white/10 bg-[#050A12]">
        <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-4 md:px-8">
          <span className="font-mono text-[10px] uppercase tracking-widest text-white/30">© 2026 hellovintora — {t.footer.rights}</span>
          <span className="font-mono text-[10px] uppercase tracking-widest text-white/30">VNT/ARCHIVE</span>
        </div>
      </div>
    </footer>
  );
};
